import { css } from '@/styled-system/css';

export const galleryContainer = css({
  position: 'relative',
  width: '100%',
  aspectRatio: '4/3',
  backgroundColor: 'bg.neutral',
  userSelect: 'none',
  lg: {
    aspectRatio: 'auto',
  },
});

export const galleryTrack = css({
  display: 'flex',
  height: '100%',
  overflowX: 'auto',
  scrollSnapType: 'x mandatory',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  lg: {
    display: 'grid',
    gap: 'tighter',
    overflow: 'hidden',
    scrollSnapType: 'none',
  },
});

export const gallerySlide = css({
  flexShrink: 0,
  width: '100%',
  height: '100%',
  scrollSnapAlign: 'start',
  lg: {
    scrollSnapAlign: 'none',
  },
});

export const galleryImage = css({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  pointerEvents: 'none',
  userSelect: 'none',
});

export const galleryViewport = css({
  display: 'block',
  height: '100%',
  overflow: 'hidden',
});

export const desktopBentoGridBase = css({
  lg: {
    // eslint-disable-next-line hotpads/no-magic-numbers, constellation/no-raw-spacing-values -- fixed desktop hero-gallery artboard height
    height: '510px',
    borderRadius: 'md',
    overflow: 'hidden',
    position: 'relative',
  },
});

export const desktopBentoGrid1 = css({
  lg: {
    gridTemplateColumns: '1fr',
    gridTemplateRows: '1fr',
  },
});

export const desktopBentoGrid2 = css({
  lg: {
    gridTemplateColumns: 'repeat(10, 1fr)',
    gridTemplateRows: '1fr',
    '& > *:nth-child(1)': { gridColumn: 'span 6' },
    '& > *:nth-child(2)': { gridColumn: 'span 4' },
  },
});

export const desktopBentoGrid3 = css({
  lg: {
    gridTemplateColumns: 'repeat(10, 1fr)',
    gridTemplateRows: '1fr 1fr',
    '& > *:nth-child(1)': { gridColumn: 'span 6', gridRow: 'span 2' },
    '& > *:nth-child(2)': { gridColumn: 'span 4' },
    '& > *:nth-child(3)': { gridColumn: 'span 4' },
  },
});

export const desktopBentoGrid4 = css({
  lg: {
    gridTemplateColumns: 'repeat(10, 1fr)',
    gridTemplateRows: '1fr 1fr',
    '& > *:nth-child(1)': { gridColumn: 'span 6' },
    '& > *:nth-child(2)': { gridColumn: 'span 4' },
    '& > *:nth-child(3)': { gridColumn: 'span 4' },
    '& > *:nth-child(4)': { gridColumn: 'span 6' },
  },
});

export const bentoImage = css({
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
  transitionProperty: 'transform',
  transitionDuration: '0.2s',
});

export const bentoButton = css({
  padding: 0,
  border: 'none',
  backgroundColor: 'transparent',
  cursor: 'pointer',
  overflow: 'hidden',
  width: '100%',
  height: '100%',
  _hover: {
    '& img': {
      transform: 'scale(1.03)',
    },
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'border.accent.brand.hero',
    outlineOffset: '-50',
  },
});

export const bentoStatic = css({
  padding: 0,
  border: 'none',
  backgroundColor: 'transparent',
  overflow: 'hidden',
  width: '100%',
  height: '100%',
});

export const desktopOverlayButtons = css({
  position: 'absolute',
  bottom: 'tighter',
  right: 'tighter',
  display: 'none',
  gap: 'tighter',
  zIndex: 'zIndexBase',
  lg: {
    display: 'flex',
  },
});

export const overlayButton = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tightest',
  backgroundColor: 'transparent.black-60',
  // oxlint-disable-next-line constellation/no-raw-color-values
  color: 'white',
  border: 'none',
  borderRadius: 'sm',
  paddingInline: 'tightest',
  paddingBlock: '150',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  whiteSpace: 'nowrap',
  fontWeight: 'regular',
  cursor: 'pointer',
  _hover: {
    backgroundColor: 'transparent.black-75',
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'border.accent.brand.hero',
    outlineOffset: '50',
  },
});

export const imageCounter = css({
  position: 'absolute',
  bottom: 'tighter',
  left: 'tighter',
  display: 'flex',
  alignItems: 'center',
  gap: 'tightest',
  backgroundColor: 'transparent.black-60',
  // oxlint-disable-next-line constellation/no-raw-color-values
  color: 'white',
  border: 'none',
  borderRadius: 'sm',
  paddingInline: 'tightest',
  paddingBlock: '150',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  whiteSpace: 'nowrap',
  fontWeight: 'regular',
  cursor: 'pointer',
  zIndex: 'zIndexBase',
  _hover: {
    backgroundColor: 'transparent.black-75',
  },
  lg: {
    display: 'none',
  },
});

export const mobileOverlayButtons = css({
  position: 'absolute',
  bottom: 'tighter',
  right: 'tighter',
  display: 'flex',
  gap: '150',
  zIndex: 'zIndexBase',
  lg: {
    display: 'none',
  },
});

export const mobileOverlayButton = css({
  display: 'flex',
  alignItems: 'center',
  gap: 'tightest',
  backgroundColor: 'transparent.black-60',
  // oxlint-disable-next-line constellation/no-raw-color-values
  color: 'white',
  border: 'none',
  borderRadius: 'sm',
  paddingInline: 'tightest',
  paddingBlock: '150',
  fontSize: 'body-sm',
  lineHeight: 'body-sm',
  whiteSpace: 'nowrap',
  fontWeight: 'regular',
  cursor: 'pointer',
  _hover: {
    backgroundColor: 'transparent.black-75',
  },
  _focusVisible: {
    outlineWidth: 'thick',
    outlineStyle: 'solid',
    outlineColor: 'border.accent.brand.hero',
    outlineOffset: '50',
  },
});
